import { useContext } from 'react';
import { Card, Field } from '../../../../layouts';
import { EstimateContext } from '../context/EstimateContext';

export default function CustomerInformationCard() {

	const { order } = useContext(EstimateContext);

	return (
		<>
			<Card
				header={'Customer Information'}
				className="field-label-30"
			>
				<Field label={'Name'} >{order.details.customerName}</Field>
				<Field label={'Address'} >{order.details.customerAddress1}</Field>
				<Field label={''} visible={!!order.details.customerAddress2}>{order.details.customerAddress2}</Field>
				<Field label={''} >{order.details.customerCityZip}</Field>
				<Field label={'Phone'} >{order.details.customerPhone}</Field>
				{
					order.details.customerEmail &&
					<Field label={'Email'} > <a href={'mailto:' + order.details.customerEmail}>{order.details.customerEmail}</a></Field>
				}
			</Card>
		</>
	);
}
